import bookingUpdateComponent from './booking-update.component';

const bookingUpdateModule = angular
  .module('bookingUpdate', [])
  .component('bookingUpdate', bookingUpdateComponent);

export default bookingUpdateModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-update/booking-update.js
 **/